import { links } from '@assets/config/setup';

/* ------ Interface ------ */
interface ILink {
    href: string;
    rel: string;
}

/* ------ Methods ------ */
const loadSetup = async (): Promise<void> => {
    links.forEach((link: ILink) => {
        const linkElement = document.createElement('link');
        linkElement.rel = link.rel;
        linkElement.href = link.href;
        document.head.appendChild(linkElement);
    });
};

export async function initializeSetup() {
    await loadSetup();
}
